import type { Prototype } from "../prototype-types";

export const nikitaTashchilinPrototypes: Prototype[] = [
  {
    id: "nt-sfl-in-side-cart",
    name: "Saved for later in side cart",
    path: "/nt/sfl-in-side-cart",
    description:
      "Explore saved-item copy, actions, ordering, and empty-active-cart behavior inside the brand side cart.",
    owner: "Nikita Tashchilin",
    createdAt: "2026-09-11",
    lastUpdated: "2026-09-11",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/nt-sfl-in-side-cart.png",
    project: "Save for Later items in side cart",
  },
];
